import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'gongzheng-service-list',
  name: '服务目录',
  icon: '服',
  group: '公证组件',
  description: '展示可办理的公证服务。',
  defaultProps: {
    title: '热门公证服务',
    limit: 8
}
}
